import styled from 'styled-components';

import * as S from './Step1';
import RoundCheckbox from 'components/checkbox/Checkbox';
import EssentialAgreement from 'components/terms/EssentialAgreement';
import SelectedAgreement from 'components/terms/SelectedAgreement';
import Service from 'components/terms/Service';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';

interface Props {
  terms: TermsTypes;
  onChange: (name: string, value: boolean) => void;
}

const Step2 = ({ terms, onChange }: Props) => {
  const handleAll = () => {
    let isFalse = Object.values(terms).filter((value) => value === false).length;
    return isFalse === 0;
  };

  return (
    <Wrapper>
      <RadioWrapper>
        <RoundCheckbox
          name="all"
          onChange={() => onChange('all', !handleAll())}
          checked={handleAll()}
          label="모두 동의합니다."
        />
      </RadioWrapper>
      <p className="warning">
        전체동의는 필수 및 선택정보에 대한 동의도 포함되어 있으며, 개별적으로도 동의를 선택하실 수
        있습니다. <br />
        선택항목에 대한 동의를 거부하시는 경우에도 서비스는 이용이 가능합니다.
      </p>
      <S.Line />
      <TermsWrapper>
        <RadioWrapper className="firstCheck">
          <RoundCheckbox
            name="term1"
            onChange={() => onChange('term1', !terms.term1)}
            checked={terms.term1}
            label="[필수] 만 14세 이상입니다."
          />
        </RadioWrapper>
        <Term>
          <h3>[필수] 서비스 이용 표준약관</h3>
          <div className="scrollbar">
            <Service />
          </div>
          <RadioWrapper>
            <RoundCheckbox
              name="term2"
              onChange={() => onChange('term2', !terms.term2)}
              checked={terms.term2}
              label="동의합니다."
            />
          </RadioWrapper>
        </Term>
        <Term>
          <h3>[필수] 개인정보 수집 이용 및 제3자 제공 동의서</h3>
          <div className="scrollbar">
            <EssentialAgreement />
          </div>
          <RadioWrapper>
            <RoundCheckbox
              name="term3"
              onChange={() => onChange('term3', !terms.term3)}
              checked={terms.term3}
              label="동의합니다."
            />
          </RadioWrapper>
        </Term>
        <Term>
          <h3>[선택] 개인정보 수집 및 민감정보 제공 동의서</h3>
          <div className="scrollbar">
            <SelectedAgreement />
          </div>

          <RadioWrapper>
            <RoundCheckbox
              name="term4"
              onChange={() => onChange('term4', !terms.term4)}
              checked={terms.term4}
              label="동의합니다."
            />
          </RadioWrapper>
        </Term>
      </TermsWrapper>
    </Wrapper>
  );
};

export default Step2;

const Wrapper = styled.div`
  padding-bottom: 32px;
  color: ${color.black2};

  h3 {
    ${font.body_medium};
  }

  h6 {
    ${font.caption1_medium};
  }

  p.warning {
    padding-top: 12px;
    ${font.body_regular};
    color: ${color.black2};
  }
`;

const RadioWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-left: auto;

  &.firstCheck {
    margin-right: auto;
    margin-left: 0;
  }
`;

const TermsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const Term = styled.div`
  display: flex;
  width: 890px;
  height: 348px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid ${color.opacityBlack01};

  & div:first-of-type {
    width: 100%;
  }

  & > p {
    width: 100%;
    height: 246px;
  }

  & div.scrollbar {
    p,
    h3 {
      color: ${color.gray700};
      ${font.caption1_regular};
    }
  }

  & .ant-table-tbody tr:first-of-type td {
    text-align: center;
    background: ${color.gray50};
    font-size: 13px;
  }

  & td {
    white-space: pre-line;
    color: ${color.gray700};
    ${font.caption1_regular};
  }
`;
